<template>
  <div class="page-title-box">
    <div class="row align-items-center">
      <div class="col-sm-6">
        <h4 class="page-title">Departamento: {{ myProfileData.dept_name }}</h4>
      </div>

      <div class="col-sm-6">
        <ol class="breadcrumb float-right">
          <li class="breadcrumb-item">
            <router-link to="/">Inicio</router-link>
          </li>
          <li class="breadcrumb-item">Professor</li>
          <li class="breadcrumb-item active">Perfil</li>
        </ol>
      </div>
    </div>
    <div class="col-sm-8 mt-4">
      <span v-if="StatusEvaluate.status == 'Em Curso'">
        <i class="mdi mdi-information"></i>
        Ja e possivel fazer o lancamento das notas dos estudantes!
      </span>
      <span v-else-if="StatusEvaluate.status == 'Pending'">
        <i class="mdi mdi-information"></i>
        Ainda nao e possivel fazer o lancamento das notas dos estudantes, comeca
        em
        {{ StatusEvaluate.date_start_academic_year }} e termica em
        {{ StatusEvaluate.date_end_academic_year }}
      </span>
      <span v-else>
        <i class="mdi mdi-information"></i>
        O lancamento das notas dos estudantes encontra-se neste momento fechado!
        <!-- <a style="text-decoration: underline" href="#">Solicitar</a> -->
      </span>
    </div>
  </div>

  <div class="row">
    <div class="col-8 col-lg-12 col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-4">
            <div class="card-header">
              <h3 class="card-title">Perfil pessoal</h3>
            </div>
            <div class="card-body">
              <br />
              <ul class="list-unstyled">
                <li class="mb-2">
                  <h4 class="">{{ myProfileData.fullName }}</h4>
                  <small class="text-center">{{ myProfileData.email }}</small>
                </li>
                <li class="mb-2">
                  <strong class="">Data de Nascimento: </strong
                  ><span class="">{{ myProfileData.birthDate }}</span>
                </li>
                <li class="mb-2">
                  <strong class="">Endere&ccedil;o: </strong
                  ><span class="">{{ myProfileData.address_location }}</span>
                </li>
                <li class="mb-2">
                  <strong class="">G&eacute;nero: </strong
                  ><span class="">{{ myProfileData.gender }}</span>
                </li>
                <li class="mb-2">
                  <strong class="">Formado na (o): </strong
                  ><span class="">{{
                    myProfileData.last_school_frequency
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-8">
            <div class="card-header">
              <h3 class="card-title">Informa&ccedil;&otilde;es adicionais</h3>
            </div>
            <div class="card-body">
              <table class="table">
                <tr>
                  <th style="width: 20%">Disciplinas que leciona</th>
                  <td>
                    <span class="justify-content-between">
                      <span
                        class="badge badge-primary badge-lg m-1"
                        v-for="(disc, index) in disciplinas"
                        :key="index"
                        >{{ disc.subject_name }}</span
                      >
                    </span>
                  </td>
                </tr>
                <tr>
                  <th>Turmas alocadas</th>
                  <td>
                    <span class="justify-content-between">
                      <span
                        class="badge badge-primary badge-lg m-1"
                        v-for="(tur, index) in turmas"
                        :key="index"
                      >
                        {{ tur.classmate_name }}
                      </span>
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal para update do novo estudante -->
  <div id="modal-overlay" v-show="isModalAddNewDept">
    <div class="container mt-2 pb-3 bg-white">
      <div class="modal-header">
        <h5 class="modal-title">Definir uma nova senha</h5>
      </div>
      <div class="modal-body">
        <div class="pt-3">
          <div class="settings-form">
            <h4 class="text-primary">Actualizar a Senha</h4>
            <form @submit.prevent="submitForm">
              <div class="row">
                <div class="form-group col-md-6">
                  <label>Nova Senha</label>
                  <div class="input-group-append">
                    <input
                      v-model="formData.nova_senha"
                      :type="showPasswordNew ? 'text' : 'password'"
                      placeholder="Nova Senha"
                      class="form-control"
                      @input="validatePassword"
                    />
                    <span class="p-viewer" @click="showPasswordClickNew">
                      <i
                        v-if="showPasswordNew == true"
                        class="fa fa-eye"
                        aria-hidden="true"
                      >
                      </i>
                      <i v-else class="fa fa-eye-slash" aria-hidden="true"> </i>
                    </span>
                  </div>
                  <p v-if="passwordError" style="color: red; font-size: 11px">
                    {{ passwordError }}
                  </p>
                </div>

                <div class="form-group col-md-6">
                  <label>Confirmar Senha</label>
                  <div class="input-group-append">
                    <input
                      v-model="formData.confirmar_senha"
                      :type="showPasswordConf ? 'text' : 'password'"
                      placeholder="Confirmar Senha"
                      class="form-control"
                    />
                    <span class="p-viewer" @click="showConfPasswordClick">
                      <i
                        v-if="showPasswordConf == true"
                        class="fa fa-eye"
                        aria-hidden="true"
                      >
                      </i>
                      <i v-else class="fa fa-eye-slash" aria-hidden="true"> </i>
                    </span>
                  </div>
                  <p v-if="passwordConfirm" style="color: red; font-size: 11px">
                    {{ passwordConfirm }}
                  </p>
                </div>
              </div>

              <button
                class="btn btn-primary float-right"
                :disabled="loading"
                type="submit"
              >
                Actualizar
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Loading :loadingData="loading"></Loading>
</template>
<script setup>
import { onMounted, ref } from "vue";
import store from "@/store";
import TeacherDashStoreModule from "./TeacherDashStoreModule";
import Loading from "@/components/Loading.vue";
import passwordStoreModule from "../login/passwordStoreModule";
import toastr from "toastr";
import { usePercentages } from "@/store/usePercentages";
import { toast } from "vue3-toastify";

const usePercentage = usePercentages();
const isModalAddNewDept = ref(false);
const user = ref({});
const disciplinas = ref({});
const turmas = ref({});
const myProfileData = ref({});
const loading = ref(false);
const StatusEvaluate = ref({});
const formData = ref({
  senha_actual: "",
  nova_senha: "",
  confirmar_senha: "",
});
const passwordError = ref("");
const passwordConfirm = ref("");
const passwordValid = ref(false);
const showPassword = ref(false);
const showPasswordConf = ref(false);
const showPasswordNew = ref(false);

function showPasswordClick() {
  if (formData.value.senha_actual == "") {
    return toast.info("por favor informe senha", {
      autoClose: 1000,
    });
  }
  showPassword.value = !showPassword.value;
}

function showPasswordClickNew() {
  if (formData.value.nova_senha == "") {
    return toast.info("por favor informe nova senha", {
      autoClose: 1000,
    });
  }
  showPasswordNew.value = !showPasswordNew.value;
}

function showConfPasswordClick() {
  if (formData.value.confirmar_senha == "") {
    return toast.info("por favor informe senha", {
      autoClose: 1000,
    });
  }
  showPasswordConf.value = !showPasswordConf.value;
}
async function getTeacherProfile() {
  try {
    loading.value = true;

    const [resp, statusEvaluateResponse] = await Promise.all([
      TeacherDashStoreModule.actions.getMyDatas(),
      TeacherDashStoreModule.actions.checkTeacherEvaluateStudent(),
    ]);

    if (statusEvaluateResponse.data) {
      localStorage.setItem(
        "AssessmentStatus",
        JSON.stringify(statusEvaluateResponse.data.status)
      );
      StatusEvaluate.value = statusEvaluateResponse.data;
    }

    if (resp.data.data.first_logg === "yes") {
      isModalAddNewDept.value = true;
    }
    console.log(resp.data.data.first_logg);

    myProfileData.value = resp.data.data;
    user.value = resp.data.user;
    disciplinas.value = resp.data.data.classmate_subject;
    turmas.value = resp.data.data.classmate_subject;

    localStorage.setItem("myProfile", JSON.stringify(resp.data.data));
    return;
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

async function getFormulasSubject() {
  const resp = await TeacherDashStoreModule.actions.getClassmateFormula();
  store.dispatch("weightSubject/add_weights", resp.data.data);
}

async function submitForm() {
  try {
    loading.value = true;

    if (formData.value.nova_senha == "") {
      loading.value = false;

      toastr.info("Por favor preencha o campo nova senha");
      return;
    }
    if (formData.value.nova_senha == "") {
      loading.value = false;

      toastr.info("Por favor preencha o campo confirmar senha");
      return;
    }

    if (formData.value.confirmar_senha != formData.value.nova_senha) {
      formData.value = "Por favor confirme a senha";
    }
    const resp = await passwordStoreModule.actions.firstLoginUpdatePassword({
      nova_senha: formData.value.nova_senha,
      confirmar_senha: formData.value.confirmar_senha,
    });

    if (resp.data == 1) {
      toast.success("Senha actualizada com sucesso", {
        autoClose: 1000,
      });
      formData.value.senha_actual = "";
      formData.value.nova_senha = "";
      formData.value.confirmar_senha = "";
      isModalAddNewDept.value = false;
    } else {
      toast.info(resp.data.message, {
        autoClose: 1000,
      });
    }
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

function validatePassword() {
  // Requisitos mínimos de segurança
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(formData.value.nova_senha);
  const hasLowerCase = /[a-z]/.test(formData.value.nova_senha);
  const hasDigit = /\d/.test(formData.value.nova_senha);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(
    formData.value.nova_senha
  );

  // Verifica se a senha atende aos critérios
  if (
    formData.value.nova_senha.length < minLength ||
    !hasUpperCase ||
    !hasLowerCase ||
    !hasDigit ||
    !hasSpecialChar
  ) {
    if (formData.value.nova_senha !== "") {
      passwordError.value =
        "A senha deve ter pelo menos 8 caracteres, incluindo maiúsculas, minúsculas, números e caracteres especiais.";
    }
  } else {
    passwordValid.value = true;
    passwordError.value = null;
  }

  if (formData.value.nova_senha == "") {
    passwordError.value = null;
  }
}
onMounted(() => {
  getTeacherProfile();
  usePercentage.fetchPercentages();

  // getFormulasSubject();
});
</script>

<style scope>
.bg-card-class {
  background-color: #1a1c2a;
  border-radius: 6px;
}

.bg-card-class span.fa.fa-times {
  cursor: pointer;
}

.password-input-group .input-wrapper {
  position: relative;
  display: flex;
  width: 100%;
}

.p-viewer,
.p-viewer2 {
  margin-left: -20px;
  margin-top: 10px;
  position: relative;
  z-index: 1;
  cursor: pointer;
}
</style>